import { z } from 'zod';
import { isRealDate, paginationQuerySchema, uuidSchema } from './common.js';
import { periodSchema } from './transport.js';
const text = (max) => z
    .string()
    .trim()
    .max(max)
    .refine((v) => !v.includes('\u0000'), 'Invalid character');
const optionalText = (max) => text(max)
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .optional();
const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD')
    .refine(isRealDate, 'Invalid calendar date');
const atLeastOne = (v) => Object.keys(v).length > 0;
const fee = z.number().int().min(0).max(1_000_000_000_000);
// ------------------------------------------------------------------- hostels
export const HOSTEL_RESIDENTS = ['boys', 'girls', 'mixed'];
const hostelFields = {
    name: text(100).min(1),
    residents: z.enum(HOSTEL_RESIDENTS),
    wardenStaffId: uuidSchema.nullable().optional(),
    status: z.enum(['active', 'inactive']),
    notes: optionalText(500),
};
export const createHostelSchema = z.object({
    ...hostelFields,
    residents: hostelFields.residents.default('mixed'),
    status: hostelFields.status.default('active'),
});
export const updateHostelSchema = z
    .object(hostelFields)
    .partial()
    .refine(atLeastOne, 'At least one field is required');
export const listHostelsQuerySchema = paginationQuerySchema.extend({
    q: text(50).optional(),
    status: z.enum(['active', 'inactive']).optional(),
});
const roomFields = {
    roomNumber: text(20).min(1),
    floor: z.number().int().min(-5).max(100).nullable().optional(),
    capacity: z.number().int().min(1).max(20),
    monthlyFeeMinor: fee,
    status: z.enum(['active', 'maintenance']),
};
export const createRoomSchema = z.object({
    ...roomFields,
    status: roomFields.status.default('active'),
});
export const updateRoomSchema = z
    .object(roomFields)
    .partial()
    .refine(atLeastOne, 'At least one field is required');
// --------------------------------------------------------------- allocations
export const createAllocationSchema = z.object({
    studentId: uuidSchema,
    roomId: uuidSchema,
    startDate: isoDate.optional(),
});
export const endAllocationSchema = z.object({ endDate: isoDate.optional() });
export const transferAllocationSchema = z.object({
    roomId: uuidSchema,
    effectiveDate: isoDate.optional(),
});
export const listAllocationsQuerySchema = paginationQuerySchema.extend({
    hostelId: uuidSchema.optional(),
    roomId: uuidSchema.optional(),
    studentId: uuidSchema.optional(),
    status: z.enum(['active', 'ended']).optional(),
});
// ---------------------------------------------------------------- out-passes
export const createOutpassSchema = z
    .object({
    studentId: uuidSchema,
    leavesOn: isoDate.optional(),
    expectedBack: isoDate,
    reason: text(300).min(1),
    escort: optionalText(200),
})
    .refine((v) => !v.leavesOn || v.expectedBack >= v.leavesOn, {
    message: 'The expected return is before the departure',
    path: ['expectedBack'],
});
export const returnOutpassSchema = z.object({ returnedOn: isoDate.optional() });
export const listOutpassesQuerySchema = paginationQuerySchema.extend({
    status: z.enum(['out', 'returned']).optional(),
    studentId: uuidSchema.optional(),
    lateOnly: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
});
// ------------------------------------------------------------------ visitors
export const createVisitorSchema = z.object({
    studentId: uuidSchema,
    visitorName: text(200).min(1),
    relationship: optionalText(100),
    phone: optionalText(30),
});
export const listVisitorsQuerySchema = paginationQuerySchema.extend({
    studentId: uuidSchema.optional(),
    insideOnly: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
});
// ------------------------------------------------------------------- charges
export const chargeHostelFeesSchema = z.object({
    period: periodSchema,
    dueDate: isoDate.optional(),
    hostelId: uuidSchema.optional(),
    studentIds: z.array(uuidSchema).min(1).max(500).optional(),
});
export const listHostelChargesQuerySchema = paginationQuerySchema.extend({
    period: periodSchema.optional(),
    hostelId: uuidSchema.optional(),
    studentId: uuidSchema.optional(),
});
//# sourceMappingURL=hostel.js.map